import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
export interface Element {
  BranchCode: number;
  BranchName: string;
  Action: string;
}
const ELEMENT_DATA: Element[] = [
  { BranchCode: 12, BranchName: 'it,', Action: '' },
  { BranchCode: 13, BranchName: 'cs,', Action: '' },
  { BranchCode: 14, BranchName: 'ece,', Action: '' },
  { BranchCode: 15, BranchName: 'me,', Action: '' },
];
@Component({
  selector: 'app-branch-pattern-master',
  templateUrl: './branch-pattern-master.component.html',
  styleUrls: ['./branch-pattern-master.component.scss'],
})
export class BranchPatternMasterComponent implements OnInit {
  displayedColumns = ['BranchCode', 'BranchName', 'Action'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  @ViewChild(MatSort) sort: MatSort;
  constructor() {}
  ngOnInit(): void {} // tslint:disable-next-line:use-lifecycle-interface
  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }
}
